import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import jobActions from '../../../actions';
import { sendRequest } from '../../../../../../helpers/saga';
import { logger } from '../../../../../../helpers/logger';
import notifications from '../../../../../../redux/notifications/actions';
import { executeAction } from '../../../../../../helpers/api';
import { keyByProperty } from '../../../../../../helpers/core';
import { t } from '../../../../../../i18n';

function* changeToWorking({ payload }) {
  try {
    const { editForm, jobId, pages } = payload;
    const { action, ...otherProps } = editForm;
    const { url, method } = action;

    const propsArray = Object.values(otherProps);

    const shift = keyByProperty(propsArray, 'name', prop => prop.value);

    const result = yield call(
      sendRequest,
      executeAction,
      { url, method, data: { shift } },
      notifications.REQUEST_ERROR,
    );

    if (result && result.data) {
      yield put(actions.saveSuccess());

      if (jobId) {
        yield put(jobActions.loadData({ id: jobId, pages }));
      }
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.common.notification.updated_successfully', { item: t('dash.jobs.bookings.shift_title') }),
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.UPDATE, changeToWorking)]);
}
